import request from '@/helpers/request'
import Vue from 'vue'
import snack from '@/helpers/snack'
import router from '@/router'
import axios from 'axios'

const notifyNetworkError = () => {
  Vue.notify({
    group: 'hasBottomNavigation',
    title: `Ошибка соединения с сервером.`,
    type: 'error',
    text: 'Попробуйте позже, или обратитесь в техническую поддержку.',
  })
}

const notifyServerError = text => {
  Vue.notify({
    group: 'hasBottomNavigation',
    title: `Серверная ошибка.`,
    type: 'error',
    text: text,
  })
}

export default {
  GET_SERVICE_TEMPLATES({ commit }, params) {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.serviceTemplates.all}`, { params }, true)
      .then(response => {
        const result = _.map(response.data.data.items, item => {
          item.active = false
          return item
        })
        commit('setServiceTemplates', result)
      })
      .catch(e => {
        console.info(e)
        snack.add(Vue.config.localization.ru.loadingError)
      })
  },

  FETCH_SERVICE_TEMPLATE({ commit }, templateID) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceTemplates.one.replace('$1', templateID)}`,
      {},
      true,
    )
  },

  GET_SERVICE_TEMPLATE_BY_ID(store, templateId) {
    axios
      .get(`${Vue.config.server}/${Vue.config.modules.crm.api.serviceTemplates.one.replace('$1', templateId)}`)
      .then(response => {
        if (response.data.result === 'success') {
          return response.data.data
        } else {
          notifyServerError('Неудалось получить шаблон')
        }
      })
      .catch(() => {
        notifyNetworkError()
      })
  },

  SAVE_SERVICE_TEMPLATE({ commit }, { service_ids, title, serviceTemplateID }) {
    return request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceTemplates.one.replace('$1', serviceTemplateID)}`,
      {
        params: {
          title,
          service_ids,
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          throw response
        }
      })
      .catch(e => {
        console.info(e)
        snack.add(Vue.config.localization.ru.errorSavingMessage)
      })
  },

  CREATE_SERVICE_TEMPLATE({ commit }, params) {
    return request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.serviceTemplates.all}`, { params }, true)
      .then(response => {
        if (response.data.result === 'success') {
          router.push({ name: 'serviceTemplatesView', params: { id: response.data.data.id } })
          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          throw response
        }
      })
      .catch(e => {
        console.info(e)
        snack.add(Vue.config.localization.ru.errorSavingMessage)
      })
  },

  REMOVE_SERVICE_TEMPLATE(context, serviceTemplateID) {
    return request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceTemplates.one.replace('$1', serviceTemplateID)}`,
      {},
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          snack.add(Vue.config.localization.ru.successRemove, 'primary')
        } else {
          throw response
        }
      })
      .catch(e => {
        console.info(e)
        snack.add(Vue.config.localization.ru.errors.removing)
        throw e
      })
  },

  async INITIALIZE_SERVICE_TEMPLATE({ commit, dispatch, state, getters }, data) {
    let serviceTemplateResponse = null

    if (data.serviceTemplateID) {
      serviceTemplateResponse = await dispatch('FETCH_SERVICE_TEMPLATE', data.serviceTemplateID)
    }
    const [servicesResponse] = await Promise.all([
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.services.allWithCompany.replace(
          '$company',
          data.companyId,
        )}`,
        {},
        true,
      ),
    ])

    const services = servicesResponse.data.data.items

    if (serviceTemplateResponse) {
      const serviceTemplate = serviceTemplateResponse.data.data
      const deletedServicesIds = _.filter(
        Object.keys(serviceTemplate.service_ids),
        serviceId => !_.some(services, service => serviceId == service.id),
      ) // тут сознательно два равно
      serviceTemplate.service_ids = _.omit(serviceTemplate.service_ids, deletedServicesIds)
      commit('setServiceTemplate', serviceTemplate)
    }

    if (!_.isEmpty(getters.serviceTemplate)) {
      const SERVICE_CATEGORIES = getters.serviceCategories
      const SERVICE_TEMPLATE = getters.serviceTemplate
      const services = SERVICE_TEMPLATE.service_ids
      _.each(SERVICE_CATEGORIES, category => {
        _.each(category.services, service => {
          const id = service.id
          if (_.has(services, id)) {
            commit('selectServiceByID', { category_id: services[id].category_id, id: id })
            if (services[id].duration !== void 0)
              commit('updateServiceCategoryDuration', {
                id: id,
                value: services[id].duration,
              })
          }
        })
      })
    }
  },
  APPLY_SERVICE_TEMPLATE_BY_ID({ store, getters, commit }, serviceTemplateID) {
    const SERVICE_CATEGORIES = getters.serviceCategories
    const SERVICE_TEMPLATE = getters.getServiceTemplateById(serviceTemplateID)
    const services = SERVICE_TEMPLATE.service_ids
    _.each(SERVICE_CATEGORIES, category => {
      _.each(category.services, service => {
        const id = service.id
        if (_.has(services, id)) {
          commit('checkServiceByID', { category_id: services[id].category_id, id: id })
          if (services[id].duration !== void 0)
            commit('updateServiceCategoryDuration', {
              id: id,
              value: services[id].duration,
            })
        }
      })
    })
    commit('checkServiceTemplateById', serviceTemplateID)
  },
  DETACH_SERVICE_TEMPLATE_BY_ID({ store, getters, commit }, serviceTemplateID) {
    const SERVICE_CATEGORIES = getters.serviceCategories
    const SERVICE_TEMPLATE = getters.getServiceTemplateById(serviceTemplateID)
    const services = SERVICE_TEMPLATE.service_ids
    _.each(SERVICE_CATEGORIES, category => {
      _.each(category.services, service => {
        const id = service.id
        if (_.has(services, id)) {
          commit('uncheckServiceByID', { category_id: services[id].category_id, id: id })
          if (services[id].duration !== void 0)
            commit('updateServiceCategoryDuration', {
              id: id,
              value: services[id].duration,
            })
        }
      })
    })
    commit('uncheckServiceTemplateById', serviceTemplateID)
  },
}
